import { render } from "./LastReceived.vue?vue&type=template&id=4fc91d06&scoped=true"
import script from "./LastReceived.vue?vue&type=script&lang=js"
export * from "./LastReceived.vue?vue&type=script&lang=js"

import "./LastReceived.vue?vue&type=style&index=0&id=4fc91d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc91d06"]])

export default __exports__